const ITEMS = [
  "Architecting Innovation",
  "Empowering Vision",
  "Securing Legacy",
  "Faith",
  "Integrity",
  "Legacy",
  "Impact",
  "Scholarship",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-serif text-xl italic tracking-wide text-gold/90 sm:text-2xl">{item}</span>
        <span className="inline-block h-1.5 w-1.5 rotate-45 bg-ember/80" aria-hidden="true" />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    aria-hidden="true"
    className="marquee-mask relative overflow-hidden border-y border-gold/15 bg-navy py-5"
  >
    <div className="animate-marquee flex w-max">
      <Row />
      <Row />
    </div>
  </div>
);

export default Marquee;
